module.exports = __webpack_public_path__ + "static/media/houses.5ff8e015.png";